export enum UserRole {
  Officeholder = "officeholder",
  Director = "director",
  CompanySecretary = "companySecretary",
  Accountant = "accountant",
  Guarantor = "guarantor",
  Employee = "employee",
}

export enum Gender {
  Male = "male",
  Female = "female",
  NonBinary = "nonBinary",
}

export enum CommonStatus {
  Active = "active",
  Pending = "pending",
  Inactive = "inactive",
}

export enum Status {
  Active = "active",
  Pending = "pending",
  Inactive = "inactive",
  Suspended = "suspended",
  Archived = "archived",
}

export enum OrganisationStatus {
  Verified = "verified",
  Unverified = "unverified",
  Pending = "pending",
  Inactive = "inactive",
  Suspended = "suspended",
  Deleted = "deleted",
}

export enum UserType {
  SuperAdmin = "superAdmin",
  LoanWriter = "loanWriter",
  Admin = "admin",
  Client = "client",
}

export enum Domicile {
  Australia = "australia",
  NewZealand = "newZealand",
  Singapore = "singapore",
  UnitedStates = "unitedStates",
}

export enum OrganisationStructure {
  Company = "company",
  Partnership = "partnership",
  Trust = "trust",
  SoleTrader = "soleTrader",
}

export enum Industry {
  AccommodationAndFoodServices = "accommodationAndFoodServices",
  AdministrativeSupportServices = "administrativeSupportServices",
  AdvisoryServices = "advisoryServices",
  AgricultureForestryFishing = "agricultureForestryFishing",
  ArtsRecreationServices = "artsRecreationServices",
  BusinessFranchises = "businessFranchises",
  Construction = "construction",
  ConsumerGoodsServices = "consumerGoodsServices",
  EducationTraining = "educationTraining",
  ElectricityGasWaterWaste = "electricityGasWaterWaste",
  FinancialServices = "financialServices",
  HealthCareSocialAssistance = "healthCareSocialAssistance",
  IndustrialMachineryGasChemicals = "industrialMachineryGasChemicals",
  InfoMediaTelecommunications = "infoMediaTelecommunications",
  LifeSciences = "lifeSciences",
  Manufacturing = "manufacturing",
  MiningResources = "miningResources",
  PersonalServices = "personalServices",
  ProfessionalScientificTechnicalServices = "professionalScientificTechnicalServices",
  PropertyRealEstate = "propertyRealEstate",
  PublicAdministrationSafety = "publicAdministrationSafety",
  OnlineRetail = "onlineRetail",
  RentalHiringRealEstate = "rentalHiringRealEstate",
  RetailTrade = "retailTrade",
  SpecialistEngineeringInfrastructureContractors = "specialistEngineeringInfrastructureContractors",
  Technology = "technology",
  ThematicReports = "thematicReports",
  TransportPostalWarehousing = "transportPostalWarehousing",
  WholesaleTrade = "wholesaleTrade",
}

export enum OrganisationType {
  Borrower = "borrower",
  Broker = "broker",
  LegalFirm = "legalFirm",
  Trustee = "trustee",
  SecurityTrustee = "securityTrustee",
  CollateralTrustee = "collateralTrustee",
  FundManager = "fundManager",
  Noteholder = "noteholder",
  Valuer = "valuer",
  Auditor = "auditor",
  Gallantree = "gallantree",
}

export enum OrganisationRelationship {
  LenderOfRecord = "lenderOfRecord",
  Generic = "generic",
  Pending = "pending",
}

export enum OrganisationVerificationType {
  FullVerification = "full",
  BasicVerification = "basic",
}

export enum OrganisationVerificationStatus {
  Pending = "pending",
  Success = "success",
  Failed = "failed",
}

export enum ProgramType {
  Bond = "bond",
  Security = "security",
  Fund = "fund",
}
export enum ProgramStructure {
  Trust = "trust",
  Company = "company",
}

export enum ProgramGoverningLaw {
  Queensland = "queensland",
  NewSouthWales = "newSouthWales",
  Victoria = "victoria",
  Singapore = "singapore",
  NewYork = "newYork",
}

export enum ProgramStatus {
  Draft = "draft",
  Active = "active",
  Pending = "pending",
  Inactive = "inactive",
  Closed = "closed",
}

export enum ProgramStage {
  Discovery = "discovery",
  RampUp = "rampUp",
  Reinvestment = "reinvestment",
  Amortisation = "amortisation",
}

export enum PaymentFrequency {
  Monthly = "monthly",
  Quarterly = "quarterly",
  Annually = "annually",
}

export enum ProgramCategory {
  CollateralisedLoanObligation = "collateralisedLoanObligation",
  CollateralisedFundObligation = "collateralisedFundObligation",
}

export enum ProgramBaseRateType {
  Fixed = "fixed",
  Floating = "floating",
}

export enum ProgramBaseRateIndex {
  Libor = "libor",
  Sofr = "sofr",
  Bbsw = "bbsw",
}

export enum ProductCategory {
  Property = "property",
  Commercial = "commercial",
}

export enum ProductType {
  FixedLoanTerm = "fixedLoanTerm",
}

export enum SecurityPosition {
  FirstRanking = "firstRanking",
}

export enum ProductStatus {
  Active = "active",
  Inactive = "inactive",
  Draft = "draft",
  Pending = "pending",
}

export enum ProgramMaturity {
  OneYear = "1year",
  TwoYears = "2years",
  ThreeYears = "3years",
  FourYears = "4years",
  FiveYears = "5years",
}

export enum NoteRank {
  AAA = "aaa",
  AA = "aa",
  A = "a",
  BBB = "bbb",
  BB = "bb",
  G = "g",
}

export enum NoteType {
  Senior = "senior",
  Mezzanine = "mezzanine",
  Equity = "equity",
}

export enum Currency {
  AUD = "aud",
  JPY = "jpy",
}

export enum HoldingStatus {
  Current = "current",
  Pending = "pending",
  Sold = "sold",
}

export enum FeeTrigger {
  Manual = "manual",
  ManualPlanned = "manualPlanned",
  Disbursement = "disbursement",
  CapitalizedDisbursement = "capitalizedDisbursement",
  UpfrontDisbursement = "upfrontDisbursement",
  LateRepayment = "lateRepayment",
  PaymentDue = "paymentDue",
  PaymentDueAppliedOnDueDates = "paymentDueAppliedOnDueDates",
  Arbitrary = "arbitrary",
  EarlyRepaymentCharge = "earlyRepaymentCharge",
  Variation = "variation",
  Cashout = "cashout",
  Extension = "extension",
  BreakCost = "breakCost",
  Arrears = "arrears",
}

export enum FeeAmountCalculationMethod {
  Flat = "flat",
  LoanAmountPercentage = "loanAmountPercentage",
  RepaymentPrincipalAmountPercentage = "repaymentPrincipalAmountPercentage",
  LoanAmountPercentageNumberOfInstallments = "loanAmountPercentageNumberOfInstallments",
  FlatNumberOfInstallments = "flatNumberOfInstallments",
  PortfolioPrincipalAmount = "portfolioPrincipalAmount",
  AaaNotesTotalPrincipal = "aaaNotesTotalPrincipal",
  AllNotesTotalPrincipal = "allNotesTotalPrincipal",
}

export enum FeeCategory {
  Loan = "loan",
  CapitalProgram = "capitalProgram",
}

export enum FeeStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum FeeCurrency {
  AUD = "aud",
  NZD = "nzd",
  USD = "usd",
  EUR = "eur",
  SNG = "sng",
}

export enum FeeState {
  Active = "active",
  Inactive = "inactive",
}

export enum FeePayment {
  Percentage = "percentage",
  Flat = "flat",
}

export enum FeeApplication {
  Optional = "optional",
  Required = "required",
}

export enum FeeApplyDateMethod {
  MonthlyFromActivation = "monthlyFromActivation",
  FirstOfEveryMonth = "firstOfEveryMonth",
  QuarterlyFromActivation = "quarterlyFromActivation",
  YearlyFromActivation = "yearlyFromActivation",
}

export enum DaysInYear {
  Actual365 = "365",
  Actual360 = "360",
  Actual366 = "366",
}

export enum LoanRank {
  Senior = "senior",
  Mezzanine = "mezzanine",
  Junior = "junior",
}
